// La confirmación de "Pasar a 1080p": qué va a pasar y cuánto cuesta, antes de cobrar
// (ADR-2026-09-27-borrador-480p-y-pasar-a-1080p). Portaleado al body y por encima del
// sheet de resultados (z-[100]) y del visor.
import React from 'react';
import { createPortal } from 'react-dom';
import { Loader2 } from 'lucide-react';
import CreditBadge from './CreditBadge';
import { ROTULO_PASAR_A_1080P } from '../lib/resolucionVideo';

export const PasarA1080pDialogo: React.FC<{
  abierto: boolean;
  creditos: number;
  segundos: number;
  procesando: boolean;
  error?: string | null;
  onCerrar: () => void;
  onConfirmar: () => void;
}> = ({ abierto, creditos, segundos, procesando, error, onCerrar, onConfirmar }) => {
  if (!abierto) return null;
  return createPortal(
    <div
      className="fixed inset-0 z-[110] flex items-end sm:items-center justify-center bg-black/40 p-4"
      onClick={onCerrar}
    >
      <div
        className="w-full max-w-md rounded-2xl bg-white p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <h3 className="text-[17px] font-semibold text-brand-black/90 mb-2">{ROTULO_PASAR_A_1080P}</h3>
        <p className="text-[14px] text-brand-black/80 leading-relaxed mb-1">
          Sale la <strong>misma toma</strong> de este borrador de {Math.round(segundos)} s en 1080p. Tarda
          entre uno y cinco minutos.
        </p>
        <p className="text-[13px] text-neutral-500 mb-5">
          Los detalles chicos (texturas, texto) pueden variar un poco.
        </p>
        {error && <p className="text-[13px] text-red-600 mb-3">{error}</p>}
        {procesando && (
          <p className="text-[13px] text-neutral-500 mb-3">
            Podés cerrar esto y seguir trabajando: el video aparece solo cuando esté listo.
          </p>
        )}
        <div className="flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onCerrar}
            className="py-2.5 px-5 rounded-xl text-[14px] font-medium text-brand-black/80 hover:bg-neutral-100"
          >
            {procesando ? 'Cerrar' : 'Cancelar'}
          </button>
          <button
            type="button"
            onClick={onConfirmar}
            disabled={procesando}
            className="inline-flex items-center gap-2 py-2.5 px-5 rounded-xl bg-brand-primary text-white text-[14px] font-semibold hover:opacity-90 disabled:opacity-60"
          >
            {procesando ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
            {procesando ? 'Pasando a 1080p…' : ROTULO_PASAR_A_1080P}
            {!procesando && <CreditBadge credits={creditos} size="sm" tone="on-primary" />}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default PasarA1080pDialogo;
